// extracted by mini-css-extract-plugin
export default {"ourteamCardWrap":"ourteamcard_ourteamCardWrap__nS87q","ourteamImage":"ourteamcard_ourteamImage__xaVV+","ourteamContent":"ourteamcard_ourteamContent__Ie3Vg"};